import Dashboard from "../../components/Dashboard";
import MaintenanceWorkOrders from "../../components/maintenance/MaintenanceWorkOrders";
import MaintenanceWorkOrderDetail from "../../components/maintenance/MaintenanceWorkOrderDetail";
import MaintenancePartsRequests from "../../components/maintenance/MaintenancePartsRequests";
import PartsCatalogRequest from "../../components/maintenance/PartsCatalogRequest";
import MyDispatch from "../../components/maintenance/MyDispatch";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BuildIcon from "@mui/icons-material/Build";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

export const maintenanceConfig = [
  {
    path: "/",
    component: Dashboard,
    label: "Dashboard",
    icon: DashboardIcon,
    showInNav: true,
  },
  {
    path: "/work-orders",
    component: MaintenanceWorkOrders,
    label: "Work Orders",
    icon: BuildIcon,
    showInNav: true,
  },
  {
    path: "/work-orders/:woId",
    component: MaintenanceWorkOrderDetail,
    showInNav: false,
  },
  {
    path: "/parts",
    component: MaintenancePartsRequests,
    label: "Parts Request",
    icon: Inventory2Icon,
    showInNav: true,
  },
  {
    path: "/parts/new",
    component: PartsCatalogRequest,
    showInNav: false,
  },
  {
    path: "/dispatch",
    component: MyDispatch,
    label: "My Dispatch",
    icon: AssignmentIndIcon,
    showInNav: true,
  },
];

export const maintenanceMetadata = {
  roleName: "Maintenance",
  defaultRoute: "/",
};
